import {ReactNode} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {useAppSelector} from "../../../store/hooks";
import {hitNegotiationApply} from "../../tracking/lead/hit_negotiation";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {LeadFormNegotiationSlot} from "./slots/LeadFormNegotiationSlot";
import {LeadFormBase} from "./LeadFormBase";

interface IProps {
    handleModalClose: (forceClose?: boolean) => void;
    onSuccessfulSubmit: (
        sentApplication: IApplicationData | null,
        offer?: IOfferDetailApplication,
        property?: IPropertyDetailApplication,
        recommendedFilters?: Record<string, string>
    ) => Promise<void>;
    initialLeadFormValues: IApplicationFormValues | null;
    customHeader: ReactNode;
    price: number | null;
}

export const LeadFormWithNegotiation = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues, customHeader, price} = props;

    const currency = useAppSelector((state) => state.mainLead.currency);

    if (!price) {
        return (
            <div className={loaderWrapperStyle}>
                <Loader />
            </div>
        );
    }

    return (
        <LeadFormBase<{negotiation: number}>
            config={{
                initialLeadFormValues,
                onSuccessfulSubmit,
                handleModalClose,
                extraDefaultValues: {negotiation: price},
                resetOnChange: [initialLeadFormValues, price],
                onBeforeSubmit: (values) => {
                    hitNegotiationApply(values.negotiation, price);
                },
                transformFormValues: (values, defaultValues) => ({
                    ...defaultValues,
                    ...values
                })
            }}
            customHeader={customHeader}
            buttonText="Negocjuj cenę"
        >
            {({formMethods}) => <LeadFormNegotiationSlot price={price} currency={currency} formMethods={formMethods} />}
        </LeadFormBase>
    );
};

const loaderWrapperStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    md: {
        width: "50rem",
        height: "30rem"
    }
});
